export const ADD_EXPERT_PAGE = "ADD_EXPERT_PAGE";
export const DEFAULT_PAGE = 0;
export const DEFAULT_PAGE_SIZE = 10;
export const MAX_KEYWORDS_COUNT = 15;
export const MIN_KEYWORD_LENGTH = 2;
export const DEFAULT_COUNTRY = {
  iso: "US",
  name: "United States"
};
export const REGEX_CITY = "^([a-zA-Z\x80-\u024F]+(?:. |-| |'))*[a-zA-Z\x80-\u024F]*$";
